import React from "react";

const FileInput = ({ label, backgroundColor, name, onChange, value }) => {
  const fileName = value ? value.name : "No file chosen";

  return (
    <div className="file-input-container input flex align-items-center">
      {/* Label for the input */}
      <label htmlFor={name} >
        {label}
      </label>

      {/* Container for the input and button */}
      <div className="file-input-wrapper">
        {/* Display the file name as text */}
        <span className="file-name">{fileName}</span>

        {/* Custom button for file input */}
        <label htmlFor={name} style={{  }} className="file-input-label bg-red smaller-text">
          Choose a file
        </label>

        {/* Hidden file input */}
        <input
          type="file"
          id={name}
          name={name}
          onChange={onChange}
          style={{ display: "none" }}
        />
      </div>
    </div>
  );
};

export default FileInput;